import { useContext, useEffect, useRef, useState } from 'react';
import { WebApiContext } from 'ascendon-web-api';
import { translateFault, generateUnhandledFault } from '../../helpers/faults';
import { payloadTypes } from '../../constants/metaDataPayloadTypes';
import { getValidCountriesList } from '../../utils/common';
import externalValidationRules from '../../config/password_config.json';

function useMetaDataCodes() {
  const { countries, states } = payloadTypes;

  const [fault, setFault] = useState(null);
  const [externalDataCountries, setExternalDataCountries] = useState(null);
  const [externalDataStates, setExternalDataStates] = useState(null);
  const WebApi = useContext(WebApiContext);

  const isMounted = useRef(true);

  useEffect(
    () => () => {
      isMounted.current = false;
    },
    [],
  );

  const getWebApiRequest = (payloadValue) =>
    WebApi.requestAll([
      {
        type: 'code',
        forceRefresh: true,
        payload: [payloadValue],
      },
    ]);

  const requestMetaDataCodes = (newRequestData) => {
    let payload;

    switch (newRequestData) {
      case 'countries':
        payload = countries;
        break;
      case 'states':
        payload = states;
        break;
      default:
        break;
    }

    getWebApiRequest(payload)
      .then(() => {
        if (isMounted.current) {
          if (payload === countries) {
            setExternalDataCountries({
              countryRules: getValidCountriesList(
                WebApi.getMetadataItemByKey('code', payload),
              ),
              externalValidationRules: externalValidationRules,
            });
          } else if (payload === 60) {
            setExternalDataStates({
              stateRules: WebApi.getMetadataItemByKey('code', payload),
              externalValidationRules: externalValidationRules,
            });
          }
        }
      })
      .catch((error) => {
        console.warn({ error });
        if (isMounted.current) {
          const code = error?.data?.data?.Code;
          let errorMsg;
          if (!code) {
            const unknownFault = generateUnhandledFault(error.data);
            errorMsg = translateFault(unknownFault).translatedMessage;
            setFault(errorMsg);
          } else {
            errorMsg = translateFault(error.data.data).translatedMessage;
            setFault(errorMsg);
          }
        }
      });
  };

  return [
    externalDataCountries,
    externalDataStates,
    fault,
    requestMetaDataCodes,
  ];
}

export default useMetaDataCodes;
